import script from "./AutoAllocStatisticsEcharts.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoAllocStatisticsEcharts.vue?vue&type=script&setup=true&lang=ts"

import "./AutoAllocStatisticsEcharts.vue?vue&type=style&index=0&id=d0c922ba&scoped=true&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0c922ba"]])

export default __exports__